export const SETTINGS = 'SETTINGS'

export const ERROR_STATE = 'ERROR_STATE'
